/** Hub routes — only exact pathname match should activate (not sibling paths). */
export const SECTION_SUBNAV_HUB_PATHS = new Set([
  '/catalogue-overview',
  '/finance-overview',
  '/business-settings',
  '/stock-overview',
  '/trading-dashboard',
  '/order-board',
  '/review-list',
  '/promotion-list',
  '/staff-list',
]);

/** Detail routes highlight their list parent in section subnav. */
export const SECTION_SUBNAV_DETAIL_PARENT: Record<string, string> = {
  '/statement-detail': '/statements',
  '/staff-detail': '/staff-list',
  '/product-editor': '/product-list',
  '/variant-editor': '/product-list',
  '/category-editor': '/category-list',
  '/modifier-group-editor': '/modifier-group-list',
  '/promotion-detail': '/promotion-list',
  '/respond-to-review': '/review-list',
  '/report-review': '/review-list',
  '/order-detail-merchant': '/order-board',
  '/incoming-order': '/order-board',
};

export function normalizeSubnavPath(path: string): string {
  const base = path.split('?')[0]?.replace(/\/$/, '') || '/';
  return base;
}

/** Whether a section subnav item should show the active state for the current pathname. */
export function isSectionSubnavLinkActive(pathname: string, itemTo: string, search = ''): boolean {
  const path = normalizeSubnavPath(pathname);
  const target = normalizeSubnavPath(itemTo);
  if (path === target) return true;
  if (path === '/order-detail-merchant' && /(?:^|[?&])from=history(?:&|$)/.test(search)) {
    return target === '/order-history-merchant';
  }
  const detailParent = SECTION_SUBNAV_DETAIL_PARENT[path];
  if (detailParent && detailParent === target) return true;
  if (SECTION_SUBNAV_HUB_PATHS.has(target)) return false;
  return false;
}
